<template>
  <!--    help-area-start-->
  <div class="help-area">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="help-img">
            <img src="assets/img/help-img.png" alt="" />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="help-containt">
            <div class="geurs-fl">
              <a href="#"><img src="assets/img/help-logo.png" alt=""/></a>
              <p>
                The Higher Education <br />
                Evaluation Platform
              </p>
            </div>
            <div class="main-title mb-50">
              <h3>
                {{ article.title }}
              </h3>
              <p>
                {{ article.subTitle }}
              </p>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-6" v-for="(item, i) in article.content" :key="'p4' + i">
                <div class="help-text">
                  <p><i class="fal fa-check"></i>{{ item.text }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- help-area-end-->
</template>

<script>
import { getArticleById } from '@/api/navItems';
import { translate } from '@/lib/utils';
// TODO: Put in Strapi

export default {
  created() {
    let id = '5fb4fd3d34941d755a466079';
    getArticleById(id).then(res => {
      this.article = translate(res);
    });
  },
  data() {
    return {
      article: {}
    };
  }
};
</script>

<style lang="scss" scoped>
.section-title h3 {
  width: 580px;
  margin-left: auto;
  margin-right: auto;
}

.section-title p {
  width: 600px;
  margin-left: auto;
  margin-right: auto;
}
</style>
